
"use strict"; // jshint ignore:line

import { Oeuvre }      from '../classes/oeuvre.js';
import { DragHandle }  from '../services/DragHandlesService.js';
import { WallService } from '../services/WallsHandlerService.js';

export default function EntitySelectionService( $rootScope,  $injector,  $oeuvresHandler,  wallsHandlerService,  dragHandlesService ) {

	var self = window.entitySelectionService = this;
	var additionalObjectService;

	/**********************/

	this.select            = selectEntity;
	this.selectEntity      = selectEntity;
	this.solveEntityType   = solveEntityType;
	this.injectTypeHandler = injectTypeHandler;

	this.refreshSelectableEntities = refreshSelectableEntities;
	this.solveSelectionType        = solveSelectionType;

	this.clear = function(){
		for( var i in this.entity_types ) injectTypeHandler( this.entity_types[i] );

		this.entity_types         = [];
		this.selected_entity      = null;
		this.selected_entity_type = null;
	};


	var $$selected_entities = [];
	var $$selection_hash = null;

	var selectionLoopTimeout, selectionLoopCounter = 0;
	function EntitySelectionLoop() {
		clearTimeout( selectionLoopTimeout );
		selectionLoopTimeout = setTimeout( EntitySelectionLoop, 250 );

		try {

			if (selectionLoopCounter % 10 == 0) refreshSelectableEntities();

			refreshSelectedEntities();

			if ($$selection_hash != ($$selection_hash = genSelectionHash( $$selected_entities ))) {
				$rootScope.$broadcast( "onSelectionChanged", $$selected_entities );
			}
		} catch( error ) {
			console.error( error );
		}

		selectionLoopCounter++;
	}


	setTimeout( EntitySelectionLoop );


	Object.defineProperty( this, "selected_entity", {
		set: function( entity ){

			if (entity) {
				if (!Array.isArray( entity )) entity = [ entity ];
				this.unselectSelected( entity );
				for (var i in entity) entity[i].$$selected = true;
			} else {
				this.unselectSelected();
			}

			EntitySelectionLoop();
		},
		get: function( v ){
			if ($$selected_entities.length == 1) return $$selected_entities[0];
			return null;
		}
	});


	var selectable_entities = [];
	Object.defineProperty( this, "selectable_entities", {
		set: function( v ){ throw new Error("Unable to set selectables!"); },
		get: function( v ){ return selectable_entities || []; }
	});


	function refreshSelectableEntities() {
		return selectable_entities = solveSelectables();
	}

	function refreshSelectedEntities() {
		return $$selected_entities = selectable_entities.filter(function( v ){ return v.$$selected });
	}

	function genSelectionHash( selected ) {
		return selected.map(function(v){
			return v.uid || v.uuid;
		}).join("|");
	}


	$rootScope.$on( "additionalWallsChanged",    refreshSelectableEntities );
	$rootScope.$on( "additionalObjectsChanged",  refreshSelectableEntities );
	$rootScope.$on( "dragHandlesChanged",        refreshSelectableEntities );
	$rootScope.$on( "arrangementOeuvresChanged", refreshSelectableEntities );

	/**********************/

	/** @Note: Lisätty 16.09.19. Tähän lopulta siirrettävä kaikki valintatoimenpiteet, tässä askel aavistus siihen suuntaan. -M */
	/** @Note: HUOM! Väliaikainen siirtymävaiheen toteutus */
	this.solveSelection = this.__solveSelectedEntity = function() {
		return {
			target  : this.selected_entity,
			targets : $$selected_entities,
			type    : solveSelectionType()
		};
	};

	this.unselectSelected = function( but ) {
		if (but) {
			if (but.indexOf('additionalObject')==-1) {
				solveSelectables('additionalObject').forEach(function( obj ){
					if (but.indexOf(obj)==-1) obj.$$selected=false;
				});
			}
			if (but.indexOf('additionalWall')==-1) {
				solveSelectables('additionalWall').forEach(function( obj ){
					if (but.indexOf(obj)==-1) obj.$$selected=false;
				});
			}
			if (but.indexOf('oeuvre')==-1) {
				solveSelectables('oeuvre').forEach(function( obj ){
					if (but.indexOf(obj)==-1) obj.$$selected=false;
				});
			}
			if (but.indexOf('dragHandle')==-1) {
				solveSelectables('dragHandle').forEach(function( obj ){
					if (but.indexOf(obj)==-1) obj.$$selected=false;
				});
			}
		} else {
			solveSelectables().forEach(function( obj ){ obj.$$selected=false; });
		}

		refreshSelectedEntities();
	};

	/**********************/

	function solveSelectionType() {
		var types = [], selected = $$selected_entities;
		for (var i in selected) {
			var type = solveEntityType( selected[i] ) || "unknown";
			if (types.indexOf(type) == -1) types.push( type );
		}
		return types.length == 0 ? null : (types.length == 1 ? types[0] : types);
	}


	function solveEntityType( entity ){
		if (entity instanceof Oeuvre)                     return "oeuvre";
		if (entity instanceof AdditionalObject)           return "additionalObject";
		if (entity instanceof WallService.AdditionalWall) return "additionalWall";
		if (entity instanceof DragHandle)                 return "dragHandle";
	}

	function selectEntity( type, entity ){
		type = type.toLowerCase();

		try {
			if( arguments.length == 1 ) selectEntity( solveEntityType( entity ), entity );

			if( !selectEntity[ type ]) throw new Error( "EntitySelectionService.selectEntity() :: No selection functionality for type '"+ type +"'" );

			selectEntity[ type ]( entity );
		} catch( err ){
			console.error( err );
		}
	}

	function injectTypeHandler( type, func ){
		type = type.toLowerCase();

		if( func == null ){

			delete selectEntity[ type ];

		} else {

			if( self.entity_types.indexOf( type ) == -1 ) self.entity_types.push( type );

			return selectEntity[ type ] = function( entity ){
				try {
					return func.call( self, entity );
				} catch( err ){
					console.error( err );
				}
			}
		}
	}

	function solveSelectables( types ) {
		var solvers = solveSelectables.solvers;

		if (!types) types = Object.keys( solvers );

		if (!Array.isArray( types )) types = [ types ];

		return types.reduce(function( t, key ){ return solvers[key] ? t.concat( solvers[ key ]() || [] ) : (console.warn( "EntitySelectionService.solveSelectables :: Unable to solve by key", key ), t); }, []);
	}

	solveSelectables.solvers = {
		oeuvre: function() { return $oeuvresHandler.oeuvres_arr; },
		additionalObject: function() {
			var objs = (additionalObjectService || $injector.get("additionalObjectService") || {}).objects || {};
			return Object.keys( objs ).map(function(i){ return objs[i]; });
		},
		dragHandle: function() {
			var objs = (dragHandlesService || $injector.get("dragHandlesService") || {}).handles_by_uuid || {};
			return Object.keys( objs ).map(function(i){ return objs[i]; });
		},
		additionalWall: function() {
			var objs = (wallsHandlerService || $injector.get("wallsHandlerService") || {}).additional_walls || {};
			return Object.keys( objs ).map(function(i){ return objs[i]; });
		}
	};
}

EntitySelectionService.$inject = new Array( "$rootScope","$injector","$oeuvresHandler","wallsHandlerService","dragHandlesService" );
